module.exports = __webpack_public_path__ + "img/invitePro.1a1b07d0.svg";